import { Tooltip } from "shared/components"
import { Markdown } from "shared/components/content/Markdown"

import { Context } from "components/Context"
import { Hint } from "components/Hint"
import { Reference } from "components/Reference"

import * as schema from "./schema"

export const WizardResult = ({ result }: { result: schema.Result }) => {
    const { title, info } = result

    return (
        <article className="mb-6 w-full rounded-md border border-solid p-4 shadow-sm">
            <header className="mb-2">
                <h2 className="text-xl font-semibold">
                    {title}
                    <Tooltip text={info.tooltip} />
                </h2>
            </header>

            <div className="flex w-full flex-col gap-4 md:flex-row">
                <div className="w-full">
                    {info.description && (
                        <p className="mt-1 text-gray-700">{info.description}</p>
                    )}
                    {info.detail && (
                        <Markdown className="prose">{info.detail}</Markdown>
                    )}
                </div>
                {(info.hint || info.context) && (
                    <aside className="w-full shrink-0 space-y-2 md:max-w-xs">
                        {info.hint && <Hint>{info.hint}</Hint>}
                        {info.context && <Context>{info.context}</Context>}
                    </aside>
                )}
            </div>
            <footer>
                <Reference text={info.reference} />
            </footer>
        </article>
    )
}
